import {getInfo, loginByEmail, logout} from 'api/login';
import Cookies from 'js-cookie';
import hex_sha1 from 'sha1';
import store from '../index'

const user = {
    state: {
        user: '',
        status: '',
        email: '',
        code: '',
        uid: undefined,
        auth_type: '',
        token: Cookies.get('_CS_USER_TAGS'),
        name: '',
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {
        SET_AUTH_TYPE: (state, type) => {
            state.auth_type = type;
        },
        SET_CODE: (state, code) => {
            state.code = code;
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_UID: (state, uid) => {
            state.uid = uid;
        },
        SET_EMAIL: (state, email) => {
            state.email = email;
        },
        SET_INTRODUCTION: (state, introduction) => {
            state.introduction = introduction;
        },
        SET_SETTING: (state, setting) => {
            state.setting = setting;
        },
        SET_STATUS: (state, status) => {
            state.status = status;
        },
        SET_NAME: (state, name) => {
            state.name = name;
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        LOGIN_SUCCESS: () => {
            console.log('login success')
        },
        LOGOUT_USER: state => {
            state.user = '';
        }
    },

    actions: {
        // 邮箱登录
        LoginByEmail({commit}, userInfo) {
            const email = userInfo.email.trim();
            return new Promise((resolve, reject) => {
                loginByEmail(email, hex_sha1(userInfo.password)).then(response => {
                    const data = response.data;
                    commit('SET_TOKEN', email);
                    commit('SET_EMAIL', email);
                    localStorage.setItem('ul', JSON.stringify({
                        'email': store.getters.token,
                        'time': new Date().getTime()
                    }));
                    if (data.status == 0) {
                        resolve();
                    } else {
                        reject(data.msg);
                    }

                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 获取用户信息
        GetInfo({commit, state}) {
            return new Promise((resolve, reject) => {
                getInfo().then(response => {
                    const data = response.data.data;
                    commit('SET_ROLES', data.roles);
                    commit('SET_NAME', data.name);
                    commit('SET_AVATAR', data.avatar);
                    commit('SET_UID', data.uid);
                    commit('SET_INTRODUCTION', data.introduction);
                    resolve(response);
                }).catch(error => {
                    reject(error);
                    Cookies.remove('_CS_USER_TAGS');
                    localStorage.clear();
                });
            });
        },

        // 登出
        LogOut({commit, state}) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '');
                    commit('SET_ROLES', []);
                    localStorage.removeItem('ul');
                    Cookies.remove('_CS_USER_TAGS');
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 前端 登出
        FedLogOut({commit}) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '');
                Cookies.remove('Admin-Token');
                alert.log("登录过期，请重新登录");
                resolve();
            });
        },

        // 动态修改权限
        ChangeRole({commit}, role) {
            return new Promise(resolve => {
                commit('SET_ROLES', [role]);
                commit('SET_TOKEN', role);
                Cookies.set('Admin-Token', role);
                resolve();
            })
        },
        // 第三方验证登录
        // LoginByThirdparty({commit, state}, code) {
        //     return new Promise((resolve, reject) => {
        //         commit('SET_CODE', code);
        //         loginByThirdparty(state.status, state.email, state.code, state.auth_type).then(response => {
        //             commit('SET_TOKEN', response.data.token);
        //             Cookies.set('Admin-Token', response.data.token);
        //             resolve();
        //         }).catch(error => {
        //             reject(error);
        //         });
        //     });
        // },

    }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js